<template>
  <div>
    <b-modal
        v-model="modalVisible"
        id="modal-login"
        ok-only
        ok-variant="outline-secondary"
        ok-title="Sair"
        centered
        title="Endereço"
    >
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="sequencial">SEQUENCIAL</label>
              <b-form-input
                  id="sequencial"
                  type="text"
                  placeholder="Sequencial"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="tipoEndereco">TIPO ENDEREÇO</label>
              <b-form-select
                  id="tipoEndereco"
                  options="teste"
                  :state="true"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="cep">CEP</label>
              <b-form-input
                  id="cep"
                  type="text"
                  placeholder="CEP"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="rua">RUA</label>
              <b-form-input
                  id="rua"
                  type="text"
                  placeholder="Rua"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="bairro">BAIRRO</label>
              <b-form-input
                  id="bairro"
                  type="text"
                  placeholder="Bairro"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="pais">PAÍS</label>
              <b-form-input
                  id="pais"
                  type="text"
                  placeholder="País"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="numero">NÚMERO</label>
              <b-form-input
                  id="numero"
                  type="text"
                  placeholder="Número"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="complemento">COMPLEMENTO</label>
              <b-form-input
                  id="complemento"
                  type="text"
                  placeholder="Complemento"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label for="estado">ESTADO</label>
              <b-form-input
                  id="estado"
                  type="text"
                  placeholder="Estado"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="cidade">CIDADE</label>
              <b-form-input
                  id="cidade"
                  type="text"
                  placeholder="Cidade"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group>
              <label for="observacoes">OBSERVAÇÕES</label>
              <b-form-input
                  id="observacoes"
                  type="text"
                  placeholder="Observações"
              />
            </b-form-group>
          </b-col>

        </b-row>

      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';

export default {
  components: {
    BFormSelect,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      modalVisible: false,
      documento: {

      },
    };
  },
  methods: {
    abrirModal(tipoOperacao, dados = null) {
      if (tipoOperacao === 'atualizar' || tipoOperacao === 'visualizar') {
        this.endereco = { ...dados };
      } else {
        this.documento = {

        };
      }

      this.modalVisible = true;
    },
    onSubmit() {
      this.$emit('salvarEndereco', { ...this.documento });

      this.modalVisible = false;
    },
  },
};
</script>
